import { render, staticRenderFns } from "./AccountMigrationCard.vue?vue&type=template&id=226ea232"
import script from "./AccountMigrationCard.vue?vue&type=script&lang=js"
export * from "./AccountMigrationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports